'use strict';

angular.module('app.home.lazypost')
    .directive('homeLazyPostDirective', function () {
        return {
            controller: 'HomeLazyPostCtrl',
            templateUrl: 'app/home/homeLazyPost/homeLazyPost.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })